export enum VideoReferenceObjectType {
  EVIDENCE = 'egrowe_evidence',
}
